import { StorefrontTagListResponseType } from "@sellar-io/api-v2/types";
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";
import { useState } from "react";

/**
 * Sequential tag-query gate. Seeds from the current first page (including
 * React Query cache on mount) and resets when that page identity changes.
 */
export const useCompletedTagQueryList = (
  firstPage: StorefrontTagListResponseType | undefined,
) => {
  const [completedQueryList, setCompletedQueryList] = useState<boolean[]>(() =>
    Array(firstPage?.length ?? 0).fill(false),
  );
  const [previousFirstPage, setPreviousFirstPage] = useState(firstPage);

  if (firstPage !== previousFirstPage) {
    setPreviousFirstPage(firstPage);
    setCompletedQueryList(Array(firstPage?.length ?? 0).fill(false));
  }

  return { completedQueryList, setCompletedQueryList };
};

export const showProductsWithoutTags = ({
  tagsQuery,
  completedQueryList,
  selectedGroupIds,
}: {
  tagsQuery: UseInfiniteQueryResult<
    InfiniteData<StorefrontTagListResponseType>,
    Error
  >;
  completedQueryList: boolean[];
  selectedGroupIds?: number[];
}) => {
  const tagQueryReturnEmpty =
    !tagsQuery.isLoading &&
    !tagsQuery.isFetching &&
    completedQueryList.length === 0;
  const queryListIsComplete =
    !!completedQueryList.length &&
    completedQueryList.every((isCompleted) => isCompleted);
  if (!selectedGroupIds?.length && (tagQueryReturnEmpty || queryListIsComplete))
    return true;

  return false;
};
